import React from 'react';
import cn from 'classnames';
import InlineFormalQuoteForm from 'formal_quote/inline_formal_quote/components/InlineFormalQuoteForm';
import { selectShowForm } from 'formal_quote/inline_formal_quote/redux/selectors';
import { getBannerConfig } from 'formal_quote/inline_formal_quote/bannerConfigs';
import { selectProduct } from 'software_products/redux/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import {
  showFormalQuoteForm,
  hideFormalQuoteForm,
} from 'formal_quote/inline_formal_quote/redux/slice';

const FormalQuoteBanner = () => {
  const dispatch = useDispatch();
  const showForm = useSelector(selectShowForm);
  const product = useSelector(selectProduct);
  const config = getBannerConfig(product?.slug);

  const onClick = () => {
    if (showForm) {
      dispatch(hideFormalQuoteForm());
    } else {
      dispatch(showFormalQuoteForm());
    }
  };

  return (
    <div className="inline-formal-quote">
      <div className="row">
        <div className="col-12 col-lg-9">
          <div className={cn('formal-quote-banner', { 'flex-column': config.subtitle })}>
            <div className="d-flex w-100">
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-center w-100">
                <div className="d-flex flex-column flex-md-row align-items-center mr-2">
                  {!config.subtitle && (
                    <div className="icon-container">
                      <img src={Spree.image_assets.formal_quote_icon} alt="Formal Quote Icon" className="img-fluid" />
                    </div>
                  )}
                  <div className="d-flex flex-column align-items-center align-items-md-start">
                    <span className="title mr-md-5">
                      {config.title}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="formal-quote-btn"
                  onClick={onClick}>
                  Request a Formal Quote
                </button>
              </div>
            </div>
            {config.subtitle && (
              <div className="w-100 mt-3">
                <span className="subtitle">
                  {config.subtitle}
                </span>
              </div>
            )}
          </div>

          <Collapse in={showForm}>
            <div className="formal-quote-form-container">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="position-relative">
                      <button
                        type="button"
                        className="close-formal-quote"
                        onClick={() => dispatch(hideFormalQuoteForm())}
                      >
                        Close Formal Quote <i className="fa fa-times" />
                      </button>
                      <InlineFormalQuoteForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default FormalQuoteBanner;
